import axios from 'axios'
import { ElMessage } from 'element-plus'
import store from './store'
import router from './router'

let base_url = 'http://127.0.0.1:8090'

export async function loadConfig() {
  try {
    const response = await fetch('/config.json')
    const config = await response.json()
    base_url = config.serverApiUrl
    http.defaults.baseURL = base_url
  } catch (e) {
    console.warn('[config] 读取 config.json 失败，使用默认地址:', base_url)
  }
}

const http = axios.create({ baseURL: base_url, timeout: 15000 })

http.interceptors.request.use(config => {
  const token = store.state.token
  if (token) config.headers.Authorization = token
  return config
})

let authFailTip = false

function handleAuthFail() {
  store.commit('CLEAR')
  if (!authFailTip) {
    authFailTip = true
    ElMessage.warning('登录已失效，请重新登录')
    setTimeout(() => { authFailTip = false }, 3000)
  }
  if (router.currentRoute.value.path !== '/login') {
    router.push('/login')
  }
}

http.interceptors.response.use(
  res => res.data,
  err => {
    const status = err.response?.status
    const isLoginApi = (err.config?.url || '').includes('/login')
    if (status === 401 && !isLoginApi) {
      handleAuthFail()
    }
    return Promise.reject(err)
  }
)

export const get = <T = any>(url: string, params?: Record<string, any>): Promise<T> =>
  http.get(url, { params }) as unknown as Promise<T>

export const post = <T = any>(url: string, data?: Record<string, any>): Promise<T> =>
  http.post(url, data) as unknown as Promise<T>
